import {connect} from 'react-redux'
import React from 'react'
import {Button, Link, Icon} from 'startlibs/lib/components'
import {isUploadingKeyImages} from 'report-components/lib/selectors'
import {togglePreview,unfinishDocument,finishDocument, changeTemplate} from 'report-components/lib/reducers'
import {withToggles} from 'startlibs/lib/hocs'
import styled from 'styled-components'
import {getColor} from 'startlibs/lib/lib'

const DeleteLink = styled.span`
  height: 3rem;
  color: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  ${Icon} {
    font-size: 16px;
  }
  .link {
    color: rgba(0,0,0,0.5);
    margin-left: .5rem;
  }
  &:hover, &:hover .link {
    color: ${getColor('alert')};
  }
`

export const reportTemplate = {
  title: (editing) => editing ? 'Report Viewer' : 'Report Editor',
  finishLabel: 'Finish report',
  editLabel: 'Edit report'
}

export const ReportFooter = connect(({report, appUI},ownProps) => ({
  isChangingTemplate: appUI.loadings[changeTemplate],
  isFinishing: appUI.loadings[finishDocument],
  isUnfinishing: appUI.loadings[unfinishDocument],

  isDocumentFinished: report.finished,
  isPreviewOpen: report.isPreviewOpen,
  isReport: report.reportUID !== null,
  isUploadingKeyImages: isUploadingKeyImages(report.reportKeyImages),
  readOnly: report.readOnly,
  navigationDisabled: ownProps.navigationDisabled || report.navigationDisabled
}),{togglePreview,unfinishDocument,finishDocument})(
  withToggles('keyImagesDialog')(
    ({
       isChangingTemplate,
       isFinishing,
       isUnfinishing,

       isDocumentFinished,
       isPreviewOpen,
       isReport,
       isUploadingKeyImages,
       readOnly,
       navigationDisabled,

       togglePreview,
       finishDocument,
       unfinishDocument,
       isLocked,
       keyImagesDialog,
       template = reportTemplate
     }) => {
      const viewing = isPreviewOpen || isDocumentFinished
      return (
        <div className="report-footer">
          <div className="footer-content">
            <div className="left-container">
              {
                !navigationDisabled &&
                <Button TAG={Link} to="/" icon="arrow-left" className="return-button">
                  Reports list
                </Button>
              }
              { false && <DeleteLink className="link">
                  <Icon icon="delete" />
                  <a className="link">Delete this report</a>
                </DeleteLink>
              }
            </div>
            {
              !readOnly && !isLocked &&
              <div className="right-container">
                {
                  !viewing && isReport &&
                  <Button disabled={isChangingTemplate} onClick={togglePreview}>Preview</Button>
                }
                {
                  isPreviewOpen &&
                  <Button icon="edit" onClick={togglePreview}>{template.editLabel}</Button>
                }
                {
                  isDocumentFinished &&
                  <Button isLoading={isFinishing || isUnfinishing} icon="edit" onClick={unfinishDocument}>
                    {template.editLabel}
                  </Button>
                }
                {
                  !isDocumentFinished &&
                  <Button isLoading={isFinishing || isUnfinishing}
                          success
                          onClick={isUploadingKeyImages ? keyImagesDialog.open : finishDocument}
                          disabled={isChangingTemplate}>
                    {template.finishLabel}
                  </Button>
                }
              </div>
            }

            {
              isLocked &&
              <div className="right-container">
                <Button locked icon="lock" disabled>Editing is Locked</Button>
              </div>
            }
          </div>
        </div>
      )
    }))



// WEBPACK FOOTER //
// ./src/javascripts/report/ReportFooter.jsx